import { render, staticRenderFns } from "./service-agreement.vue?vue&type=template&id=e23c92bc&scoped=true"
import script from "./service-agreement.vue?vue&type=script&lang=ts"
export * from "./service-agreement.vue?vue&type=script&lang=ts"
import style0 from "./service-agreement.vue?vue&type=style&index=0&id=e23c92bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23c92bc",
  null
  
)

export default component.exports